import { z } from "zod";

export const newTicketSchema = (t: (key: string) => string) =>
  z.object({
    subject: z.string().min(3, t("subject-min")),
    text: z.string().min(10, t("message-min")),
  });

export type NewTicketFormValues = z.infer<ReturnType<typeof newTicketSchema>>;

export const replySchema = (t: (key: string) => string) =>
  z.object({
    text: z.string().min(1, t("required")),
  });

export type ReplyFormValues = z.infer<ReturnType<typeof replySchema>>;

// Server-side input validation for the replyToTicket action.
// No translator — server returns stable error codes; UI does the i18n.
export const replyServerSchema = z.object({
  ticketId: z.string().trim().min(1),
  text: z.string().min(1).max(5000),
});
